/**
 * Page knowledge hub detail structured data mapper
 * return structured data from page content type "PageKnowledgeHubDetail"
 *
 * @param {Object} data - page data
 * @param {Object} options - mapper options
 * @param {String} options.code - locale code e.g nl_NL
 * @param {String} options.siteUrl - site url e.g https://www.adyen.com
 * @return {Object} - structured data with JSON-LD format to be used in page header
 */

export default (pageData, options) => {
  if (!pageData) {
    return null
  }
  const { locale, siteUrl } = options
  const content = pageData.content || {}
  const imageUrl = content.image?.[0]?.original?.transform
  const authorsList = [
    {
      '@type': 'Organization',
      name: 'Adyen',
      // home page url
      url: locale === 'en' ? siteUrl : `${siteUrl}/${locale}`
    }
  ]
  const author = content.author
  if (author) {
    authorsList.push({
      '@type': 'Person',
      name: author.name,
      jobTitle: [author.role, author.companyName].filter(Boolean).join(' - ')
    })
  }
  return {
    '@context': 'https://schema.org',
    '@type': 'BlogPosting',
    headline: content.title,
    image: [imageUrl],
    datePublished: content.date,
    dateModified: pageData.publishedAt,
    author: authorsList
  }
}
